// COUNTDOWN WEB COMPONENT
class CountdownTimer extends HTMLElement {
    constructor() {
        super();
        this.countdownExpired = false;
        this.intervalId = null;
    }

    connectedCallback() {
        // Get the target date from text content or date attribute
        const dateString = this.getAttribute('date') || this.textContent.trim();
        
        if (!dateString) {
            console.warn('CountdownTimer: No date provided');
            return;
        }

        this.targetDate = new Date(dateString).getTime();
        
        if (isNaN(this.targetDate)) {
            console.warn('CountdownTimer: Invalid date format');
            return;
        }

        // Initialize the timer
        this.updateTimer();
        this.style.opacity = "1";
        
        // Start interval if not expired
        if (!this.countdownExpired) {
            this.intervalId = setInterval(() => this.updateTimer(), 1000);
        }
    }

    disconnectedCallback() {
        // Clean up interval when element is removed
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }

    updateTimer() {
        const now = new Date().getTime();
        const diff = this.targetDate - now;

        if (diff < 0) {
            this.countdownExpired = true;
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        // Format with leading zeros
        const formattedDays = days <= 9 ? `0${days}` : days;
        const formattedHours = hours <= 9 ? `0${hours}` : hours;
        const formattedMinutes = minutes <= 9 ? `0${minutes}` : minutes;
        const formattedSeconds = seconds <= 9 ? `0${seconds}` : seconds;

        if (this.countdownExpired) {
            const successText = this.getAttribute('data-success');
            const successUrl = this.getAttribute('data-success-url');

            if (successText) {
                if (successUrl) {
                    this.innerHTML = `<a href="${successUrl}" target="_blank">${successText}</a>`;
                } else {
                    this.innerHTML = successText;
                }
            } else {
                this.innerHTML = '';
            }
        } else {
            const daysDisplay = days > 0 ? `${formattedDays} days : ` : '';
            this.innerHTML = `${daysDisplay}${formattedHours} hours : ${formattedMinutes} minutes : ${formattedSeconds} seconds`;
        }
    }
}

// Register the custom element
customElements.define('countdown-timer', CountdownTimer);